import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import stripeLogo from '@/assets/images/common/stripe-wordmark-blurple.png';
// ローディング表示
function LoadingForStripe(): ReactElement {
    const { t } = useTranslation('checkout');
    return (
        <div className="h-screen w-screen flex flex-col justify-center items-center">
            <div className="flex justify-center items-end absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 space-x-3">
                <div className="animate-ping h-4  w-1 bg-kotomilThemaColor rounded-full [animation-delay:100ms]" />
                <div className="animate-ping h-8  w-1 bg-kotomilThemaColor rounded-full [animation-delay:200ms]" />
                <div className="animate-ping h-6  w-1 bg-kotomilThemaColor rounded-full" />
                <div className="animate-ping h-8  w-1 bg-kotomilThemaColor rounded-full [animation-delay:900ms]" />
                <div className="animate-ping h-12 w-1 bg-kotomilThemaColor rounded-full [animation-delay:400ms]" />
            </div>
            <div className="pt-40 mx-8 flex flex-col justify-center items-center">
                <p className="text-2xl leading-[1.8] tracking-widest">{t('loading.hero')}</p>
                <p className="mt-10 text-lg leading-[1.8] tracking-widest">
                    {t('loading.description')}
                </p>
            </div>
            <div className="mt-10 flex justify-center items-center space-x-2">
                <p className="text-2xl leading-[1.8] tracking-widest">{t('loading.poweredBy')}</p>
                <img src={stripeLogo} alt="Stripe" className="w-44" />
            </div>
        </div>
    );
}

export default LoadingForStripe;
